
export const purchaseFields = [
  {
    label: "Supplier Name",
    value: "PartyDisplayName",
    flag: "required",
    type: "info",
  },
  { label: "Supplier GSTIN", value: "GSTIN", flag: "required", type: "info" },
  {
    label: "Place of supply",
    value: "PlaceOfSupply",
    flag: "required",
    type: "info",
  },
  {
    label: "Voucher Number",
    value: "VoucherNumber",
    flag: "required",
    type: "info",
  },
  {
    label: "Purchase Date",
    value: "EntryDate",
    flag: "required",
    type: "info",
  },

  {
    label: "Supplier order Number",
    value: "Supplier order Number",
    flag: "required",
    type: "info",
  },
  {
    label: "Supplier order Date",
    value: "Supplier order Date",
    flag: "required",
    type: "info",
  },

  {
    label: "Item Code",
    value: "ItemCode",
    flag: "item",
  },
  {
    label: "Item Name",
    value: "ItemName",
    flag: "item",
  },
  {
    label: "Income/Sales Account",
    value: "Income/Sales Account",
    flag: "non-item",
  },

  {
    label: "Taxability",
    value: "Taxability",
    flag: "required",
  },
  {
    label: "GST Rate (%)",
    value: "GSTRate",
    flag: "taxable",
  },
  {
    label: "HSN/SAC Code",
    value: "HSN/SACCode",
    required: 2,
  },
  {
    label: "Quantity",
    value: "ItemQuantity",
    flag: "item",
  },
  {
    label: "Units",
    value: "MeasurementCD",
    flag: "item",
  },
  {
    label: "Rate",
    value: "ItemRate",
    flag: "item",
  },

  {
    label: "Amount",
    value: "ItemAmount",
    flag: "required",
  },

  {
    label: "Discount",
    value: "ItemDiscount",

    flag: "item",
  },

  {
    label: "Taxable Amount",
    value: "TotalTaxableAmount",
    flag: "required",
  },

  {
    label: "GST",
    value: "GST",
    flag: "taxable",
  },
  {
    label: "GST Cess (₹)",
    value: "CessAmount",
    flag: "taxable",
  },
  {
    label: "Net Amount",
    value: "NetAmount",
    flag: "required",
  },

  {
    label: "Sales Account",
    value: "AccountName",
    flag: "required",
  },

  {
    label: "Additional Discount",
    value: "Discount/Additions, if any(+/-)",
  },
  {
    label: "Transportation mode",
    value: "dispatch",
  },
  {
    label: "Vechicle Number",
    value: "vechicleNumber",
    flag: "dispatch",
  },
  {
    label: "Date of Dispatch",
    value: "dispatchDate",
    flag: "dispatch",
  },
  {
    label: "EWay Bill Number",
    value: "billNumber",
    flag: "dispatch",
  },
  {
    label: "Payment Type",
    value: "paymentType",
    flag: "required",
    type: "payment",
  },
  {
    label: "Paid Amount",
    value: "amount",
    flag: "payment",
  },
  {
    label: "Paid To Account (Dr)",
    value: "amount",
    flag: "payment",
  },
  {
    label: "Receipt Series Name",
    value: "amount",
    flag: "payment",
  },
];

export const salesFields = [
  {
    label: "Customer Name",
    value: "PartyDisplayName",
    flag: "required",
    type: "info",
  },
  { label: "Customer GSTIN", value: "GSTIN", flag: "required", type: "info" },
  {
    label: "Place of supply",
    value: "PlaceOfSupply",
    flag: "required",
    type: "info",
  },
  {
    label: "Invoice Date",
    value: "InvoiceDate",
    flag: "required",
    type: "info",
  },
  {
    label: "Customer Order Number",
    value: "CustomerOrderNumber",
    type: "info",
  },
  { label: "Customer Order Date", value: "CustomerOrderDate", type: "info" },
  {
    label: "Item Code",
    value: "ItemCode",
    flag: "item",
  },
  {
    label: "Item Name",
    value: "ItemName",
    flag: "item",
  },
  {
    label: "Income/Sales Account",
    value: "Income/Sales Account",
    flag: "non-item",
  },
  {
    label: "Taxability",
    value: "Taxability",
    flag: "required",
  },
  {
    label: "GST Rate (%)",
    value: "GSTRate",
    flag: "taxable",
  },
  {
    label: "HSN/SAC Code",
    value: "HSN/SACCode",
    required: 2,
  },
  {
    label: "Quantity",
    value: "ItemQuantity",
    flag: "item",
  },
  {
    label: "Units",
    value: "MeasurementCD",
    flag: "item",
  },
  {
    label: "Rate",
    value: "ItemRate",
    flag: "item",
  },

  {
    label: "Amount",
    value: "ItemAmount",
    flag: "required",
  },

  {
    label: "Discount",
    value: "ItemDiscount",

    flag: "item",
  },

  {
    label: "Taxable Amount",
    value: "TotalTaxableAmount",
    flag: "required",
  },

  {
    label: "GST",
    value: "GST",
    flag: "taxable",
  },
  {
    label: "GST Cess (₹)",
    value: "CessAmount",
    flag: "taxable",
  },
  {
    label: "Net Amount",
    value: "NetAmount",
    flag: "required",
  },

  {
    label: "Sales Account",
    value: "AccountName",
    flag: "required",
  },

  {
    label: "Additional Discount",
    value: "Discount/Additions, if any(+/-)",
  },
  {
    label: "Transportation mode",
    value: "dispatch",
  },
  {
    label: "Vechicle Number",
    value: "vechicleNumber",
    flag: "dispatch",
  },
  {
    label: "Date of Dispatch",
    value: "dispatchDate",
    flag: "dispatch",
  },
  {
    label: "EWay Bill Number",
    value: "billNumber",
    flag: "dispatch",
  },
  {
    label: "Payment Type",
    value: "paymentType",
    flag: "required",
    type: "payment",
  },
  {
    label: "Received Amount",
    value: "amount",
    flag: "payment",
  },
  {
    label: "Received To Account (Dr)",
    value: "amount",
    flag: "payment",
  },
  {
    label: "Receipt Series Name",
    value: "amount",
    flag: "payment",
  },
];

export const paymentField = [
  { label: "Invoice Number Series", value: "SerialNumber" },
  { label: "Voucher Number", value: "VoucherNumber" },
  { label: "Payment Method", value: "TransactionTypeCD" },
  { label: "Paid From (Cr)", value: "AccountName" },
  { label: "Paid To (Dr)", value: "AccountName" },
  { label: "Payable Amount", value: "Amount" },
  { label: "TDS Applicable", value: "TDSApplicableCD" },
  { label: "TDS Amount", value: "TDSAmount" },
  { label: "Remark/Narration", value: "Comments" },
  { label: "Bank Reference Number", value: "BankReferenceNumber" },
];

export const journalEntry = [
  { label: "Voucher Number", value: "VoucherNumber" },
  { label: "Journal Date", value: "EntryDate" },
  { label: "Narration", value: "Comments" },
  { label: "Debit", value: "DebitAmount" },
  { label: "Credit", value: "CreditAmount" },
];

export const receiptEntry = [
  { label: "Receipt Date", value: "" },
  { label: "Receipt voucher No", value: "" },
  { label: "Received from", value: "" },
  { label: "Receipt to", value: "" },
  { label: "Amount", value: "" },
  { label: "Remarks/Narration", value: "" },
  { label: "Bank Reference Number", value: "" },
];

export const debitNote = [
  { label: "Party Name", value: "ConsigneeName" },
  { label: "Debit Note Number", value: "CrDrNoteNumber" },
  { label: "Debit Note Date", value: "CrDrNoteDate" },
  { label: "Original Invoice Number", value: "Original Invoice Number" },
  { label: "Ineligible ITC", value: "Ineligible ITC" },
  { label: "Reverse Charge Applicable", value: "Reverse Charge Applicable" },
  { label: "Item Code", value: "ItemCode" },
  { label: "Item Name", value: "ItemName" },
  { label: "HSN/SAC Code", value: "HSNSACCode" },
  { label: "Quantity", value: "Quantity" },
  { label: "Units", value: "UnitTypeCD" },
  { label: "Rate", value: "ItemRate" },
  { label: "Amount", value: "ItemAmount" },
  { label: "Discount", value: "ItemDiscount" },
  { label: "Taxable Amount", value: "ItemAmount" },
  { label: "GST Rate", value: "GSTRate" },
  { label: "GST Cess", value: "GSTCess" },
  { label: "Net Amount", value: "NetAmount" },
  { label: "Payment Type", value: "PaymentType" },
  { label: "Discount/Additions", value: "DD" },
  { label: "Ledger Account", value: "lA" },
  { label: "Description", value: "comment" },
];

export const creditNote = [
  { label: "Party Name", value: "ConsigneeName" },
  { label: "Credit Note Number", value: "CrDrNoteNumber" },
  { label: "Credit Note Date", value: "CrDrNoteDate" },
  { label: "Original Invoice Number", value: "Original Invoice Number" },
  { label: "Ineligible ITC", value: "Ineligible ITC" },
  { label: "Reverse Charge Applicable", value: "Reverse Charge Applicable" },
  { label: "Item Code", value: "ItemCode" },
  { label: "Item Name", value: "ItemName" },
  { label: "HSN/SAC Code", value: "HSNSACCode" },
  { label: "Quantity", value: "Quantity" },
  { label: "Units", value: "UnitTypeCD" },
  { label: "Rate", value: "ItemRate" },
  { label: "Amount", value: "ItemAmount" },
  { label: "Discount", value: "ItemDiscount" },
  { label: "Taxable Amount", value: "ItemAmount" },
  { label: "GST Rate", value: "GSTRate" },
  { label: "GST Cess", value: "GSTCess" },
  { label: "Net Amount", value: "NetAmount" },
  { label: "Payment Type", value: "PaymentType" },
  { label: "Discount/Additions", value: "DD" },
  { label: "Description", value: "comment" },
];

export const BankSettingsFields = [
  { label: "Bank Name", value: "Bank Name" },
  { label: "IFSC code", value: "IFSC code" },
  { label: "Swift code", value: "Swift code" },
  { label: "Branch Name", value: "Branch Name" },
  { label: "Bank account number", value: "Bank account number" },
  { label: "Cash", value: "Cash" },
];

export const ContactPersonDetails = [
  { label: "Contact Person Name", value: "Contact Person Name" },
  { label: "Contact Person Designation", value: "Contact Person Designation" },
  { label: "Contact Person Dial Code", value: "Contact Person Dial Code"},
  { label: "Contact Person Number", value: "Contact Person Number" },
  { label: "Contact Person Dial Code", value: "Contact Person Dial Code"},
  {
    label: "Contact Person WhatsApp Number",
    value: "Contact Person WhatsApp Number",
  },
  { label: "Contact Person Email", value: "Contact Person Email" },
  { label: "Comments/Remark", value: "Contact Comments" },
];

export const GoodsFields = [
  { label: "Item Code", value: "Item Code", flag: "required" },
  { label: "Item Name", value: "Item Name", flag: "required" },
  { label: "Item Type", value: "Item Type", flag: "required" },
  { label: "Category", value: "Category", flag: "required" },
  {
    label: "Unit of Measurement",
    value: "Unit of Measurement",
    flag: "required",
  },
  { label: "Sales Account", value: "Sales Account", flag: "required" },
  { label: "Purchase Account", value: "Purchase Account", flag: "required" },
  { label: "HSN/SAC Code", value: "HSNORSacCode" },
  { label: "Taxability", value: "Taxability", flag: "required" },
  // { label: "Currency", value: "Currency", flag: "required" },
  { label: "Price type", value: "priceType", flag: "required" },
  { label: "Selling Rate", value: "sellingRate" },
  { label: "Selling Discount Type", value: "sellingDiscountType" },
  { label: "Selling Discount", value: "sellingDiscount" },
  // { label: "Selling Discount Amt", value: "sellingDiscountAmt" },
  // { label: "Selling Taxable Amt", value: "sellingTaxableAmt" },
  { label: "Selling GST rate", value: "sellingGst" },
  // { label: "Selling Net Amount", value: "sellingNetAmount" },
  { label: "Selling Effective From", value: "sellingEffectiveFrom" },
  { label: "Selling Effective To", value: "sellingEffectiveTo" },
  { label: "Purchase Rate", value: "purchaseRate" },
  { label: "Purchase Discount Type", value: "purchaseDiscountType" },
  { label: "Purchase Discount", value: "purchaseDiscount" },
  // { label: "Purchase Discount Amt", value: "purchaseDiscount Amt" },
  // { label: "Purchase Taxable Amt", value: "purchaseTaxableAmt" },
  { label: "Purchase GST rate", value: "purchaseGst" },
  // { label: "Purchase Net Amount", value: "purchaseNetAmount" },
  { label: "Purchase Effective From", value: "purchaseEffectiveFrom" },
  { label: "Purchase Effective To", value: "purchaseEffectiveTo" },
];

export const PartiesFields = [
  { label: "GSTIN", value: "GSTIN", user: "registered" },
  { label: "GST Category", value: "GST Category", flag: "required" },
  {
    label: "Permanent Account Number",
    value: "Permanent Account Number",
    user: "registered",
  },
  { label: "Entity", value: "Entity" },
  { label: "Place of Supply", value: "Place of Supply" },
  { label: "Legal Name", value: "Legal Name", flag: "required" },
  { label: "Display Name", value: "Display Name", flag: "required" },
  { label: "Group", value: "Group", flag: "required" },
  { label: "Credit Limit", value: "Credit Limit" },
  { label: "Credit Period", value: "Credit Period" },
  { label: "Billing Currency", value: "Billing Currency" },
  { label: "Email", value: "Email" },
  { label: "Country Dial Code", value: "Country dial Code "},
  { label: "Contact Number", value: "Contact Number" },
  { label: "Country Dial Code", value: "Country dial Code "},
  { label: "WhatsApp Number", value: "WhatsApp Number" },

  { label: "Billing Country", value: "Billing Country" },
  { label: "Billing Pincode", value: "Billing Pincode" },
  {
    label: "Billing State/Province",
    value: "Billing State/Province",
  },
  {
    label: "Billing Address District",
    value: "Billing Address District",
  },
  { label: "Billing City", value: "Billing City" },
  { label: "Billing Address", value: "Billing Address" },
];

export const supplieExtraFeild = [
  { label: "Udayam Number", value: "Udayam Number" },
  { label: "MEMS Type", value: "MEMS Type" },
  { label: "TDS", value: "TDS" },
];

export const partiesDeliveryFields = [
  { label: "Delivery Country", value: "Delivery Country" },
  { label: "Delivery Pincode", value: "Delivery Pincode" },
  {
    label: "Delivery State/Province",
    value: "Delivery State/Province",
  },
  {
    label: "Delivery Address District",
    value: "Delivery Address District",
  },
  { label: "Delivery City", value: "Delivery City" },
  { label: "Delivery Address", value: "Delivery Address" },
  { label: "Consignee Name", value: "Consignee Name" },
  { label: "Consignee GSTIN", value: "Consignee GSTIN" },
];

export const partiesShippingFields = [
  { label: "Shipping Country", value: "Shipping Country" },
  { label: "Shipping Pincode", value: "Shipping Pincode" },
  {
    label: "Shipping State/Province",
    value: "Shipping State/Province",
  },
  {
    label: "Shipping Address District",
    value: "Shipping Address District",
  },
  { label: "Shipping City", value: "Shipping City" },
  { label: "Shipping Address", value: "Shipping Address" },
];

export const accountFields = [
  { label: "Account Name", value: "account name", flag: "required" },
  { label: "Under Group", value: "account group", flag: "required" },
  { label: "Top-Level Group", value: "root", flag: "required" },
  { label: "Account Type", value: "account type", flag: "required" },
  { label: "Credit", value: "credit" },
  { label: "Debit", value: "debit" },
];

export const GroupFields = [
  { label: "Group Name", value: "groupname", flag: "required" },
  { label: "Under Group", value: "parent", flag: "required" },
  { label: "Top-Level Group", value: "root", flag: "required" },
  { label: "Group Type", value: "grouptype", flag: "required" },
];

export const saleGeneral = [
  { label: "Customer Name", value: "customer Name", flag: "required" },
  { label: "Customer GSTIN", value: "customer gstin", flag: "required" },
  { label: "Billing Address", value: "billing Address" },
  { label: "Delivery Address", value: "delivery Address" },
  { label: "Place of Supply", value: "place Of Supply", flag: "required" },
  { label: "Invoce Number", value: "invoice Number", flag: "required" },
  { label: "Billing currency", value: "billong Currency", flag: "required" },
  { label: "Invoice Date", value: "invoice Date" },
  { label: "Customer Order Number", value: "customer Order Number" },
  { label: "Customer Order Date", value: "customer Order Date" },
  { label: "Taxablity", value: "taxablity", flag: "required" },
];

export const salesItemWiseEnteryTable = [
  { label: "Item Code", value: "item Code", flag: "required" },
  { label: "Item Name", value: "item Name", flag: "required" },
  { label: "Price Type", value: "price Type" },
  {
    label: "Item wise Entity GST",
    value: "itemWiseentityGST",
    flag: "required",
  },
  { label: "Item wise Entity HSN/SA", value: "itemHSN/SA" },
  { label: "Quantity", value: "quantity", flag: "required" },
  { label: "Units", value: "itemunits", flag: "required" },
  { label: "Rate", value: "Rate", flag: "required" },
  { label: "Item Amount", value: "itemAmount" },
  { label: "Discount", value: "discount" },
  { label: "Taxable Amount", value: "taxableAmount" },
  { label: "GST Amount", value: "gstAmount" },
  { label: "Net Amount", value: "netAmount" },
];

export const salesNonItemWiseEnteryTable = [
  {
    label: "Non Item Income/Sale Amount",
    value: "income/sale amount",
    flag: "required",
  },
  { label: "Non Item GST", value: "Non item gst", flag: "required" },
  { label: "Non Item HSN/SA", value: "Non item hsn/sa" },
  { label: "Description", value: "Description" },
  {
    label: "Non Item Taxable Amount",
    value: "Non item taxable",
    flag: "required",
  },
  { label: "Non Item GST Amount", value: "Don item gstAmount" },
  { label: "Net Amount", value: "Net amount" },
];
export const salesTcs = [
  { label: "Additional Discount Type", value: "Discount Type" },
  { label: "Discount Amount", value: "Discount Value" },
  { label: "TCS", value: "Tcs Section" },
  { label: "TCS(%)", value: "Tcs Percent" },
  { label: "TCS Amount", value: "Tcs Amount" },
  { label: "Round Off", value: "RoundOff" },
];
export const salesRecipt = [
  { label: "Cash/Bank Receipt Number", value: "Cash Receipt Number" },
  { label: "Payment Type", value: "Payment Type" },
  { label: "Received To Account(Dr)", value: "Reacived To Account" },
  { label: "Received Amount", value: "Recived Amount" },
];

export const saleDispatch = [
  { label: "Transpotation Mode", value: "Transpotation Mode" },
  { label: "Vehicle Number", value: "Vehicle Number" },
  { label: "Date of Dispatch", value: "Date Of Dispatch" },
  { label: "EWAY Bill Number", value: "EwayBill" },
];
export const purchaseGeneral = [
  { label: "Supplier Name", value: "Supplier Name", flag: "required" },
  { label: "Supplier GSTIN", value: "Supplier gstin", flag: "required" },
  { label: "Supplier Address", value: "Supplier Address" },
  { label: "Source of Supply", value: "Source Of Supply", flag: "required" },
  { label: "Voucher Number", value: "Voucher Number", flag: "required" },
  { label: "Billing currency", value: "Billong Currency", flag: "required" },
  { label: "Voucher Date", value: "Voucher Date" },
  { label: "Supplier Invoice Number", value: "Supplier Invoice Number" },
  { label: "Supplier Invoice Date", value: "Supplier Invoice Date" },
  { label: "Taxablity", value: "taxablity", flag: "required" },
];

export const purchaseItemWiseEnteryTable = [
  { label: "Item Code", value: "Item Code", flag: "required" },
  { label: "Item Name", value: "Item Name", flag: "required" },
  { label: "Price Type", value: "Price Type" },
  {
    label: "Item wise Entity GST",
    value: "Item Wise Entity GST",
    flag: "required",
  },
  { label: "Item wise Entity HSN/SA", value: "Item HSN/SA" },
  { label: "Quantity", value: "Quantity", flag: "required" },
  { label: "Units", value: "Item units", flag: "required" },
  { label: "Rate", value: "Rate", flag: "required" },
  { label: "Amount", value: "Amount" },
  { label: "Discount", value: "Discount" },
  { label: "Taxable Amount", value: " Taxable Amount" },
  { label: "GST Amount", value: "gst Amount" },
  { label: "Cess", value: "cess" },
  { label: "Net Amount", value: "Net Amount" },
];
export const purchaseNonItemWiseEnteryTable = [
  {
    label: "Expense/Purchase Amount",
    value: "Expense/Purchase amount",
    flag: "required",
  },
  { label: "Non Item GST", value: "Non item gst", flag: "required" },
  { label: "Non Item HSN/SA", value: "Non item HSA/SA" },
  { label: "Description", value: "Description" },
  {
    label: "Non Item Taxable Amount",
    value: "Non Item Taxable",
    flag: "required",
  },
  { label: "Non Item GST Amount", value: "Non item gstAmount" },
  { label: "Non Item Cess Amount ", value: "Non Item Cess Amount" },
  { label: "Net Amount", value: "Net Amount" },
  { label: "Total", value: "Total" },
];
export const purchaseTcs = [
  { label: "Additional Discount Type", value: "Discount Type" },
  { label: "Discount Amount", value: "Discount Value" },
  { label: "TDS", value: "Tds Section" },
  // { label: "TDS(%)", value: "Tds Percent" },
  // { label: "TDS Amount", value: "Tcd Amount" },
  { label: "TCS", value: "Tcs Section" },
  // { label: "TCS(%)", value: "Tcs Percent" },
  // { label: "TCS Amount", value: "Tcs Amount" },
  { label: "Round Off", value: "RoundOff" },
];
export const purchaseRecipt = [
  { label: "Cash/Bank Payment Number", value: "Cash Payment Number" },
  { label: "Payment Type", value: "Payment Type" },
  { label: "Paid To Account(Dr)", value: "Paid To Account" },
  { label: "Paid Amount", value: "Paid Amount" },
  { label: "Credit Period(in days)", value: "Credit Period" },
  { label: "Due Date", value: "Due Date" },
];

export const debitNoteGeneral = [
  { label: "Customer/Suppiler", value: "Customer/Suppiler", flag: "required" },
  {
    label: "Customer/Supplier GSTIN",
    value: "Customer/Supplier gstin",
    flag: "required",
  },
  { label: "Billing Address", value: "Billing Address" },
  { label: "Delivery Address", value: "Delivery Address" },
  { label: "Place of Supply", value: "Place Of Supply", flag: "required" },
  { label: "Debit Note Number", value: "Debit note  Number", flag: "required" },
  { label: "Billing currency", value: "Billing Currency", flag: "required" },
  { label: "Debit Note Date", value: "Debit Note Date" },
  { label: "Customer Invoice Number", value: "Customer Invoice Number" },
  { label: "Taxablity", value: "taxablity", flag: "required" },
];

export const debitNoteItemWiseEnteryTable = [
  { label: "Item Code", value: "Item Code", flag: "required" },
  { label: "Item Name", value: "Item Name", flag: "required" },
  { label: "Reason", value: "Reason" },
  {
    label: "Item wise Entity GST",
    value: "Item Wise entity GST",
    flag: "required",
  },
  { label: "Item wise Entity HSN/SA", value: "Item HSN/SA" },
  { label: "Quantity", value: "Quantity", flag: "required" },
  { label: "Unit", value: "Item Unit", flag: "required" },
  { label: "Rate", value: "Rate", flag: "required" },
  // { label: "Item Amount", value: "Item Amount" },
  { label: "Discount", value: "Discount" },
  // { label: "Taxable Amount", value: "Taxable Amount" },
  // { label: "GST Amount", value: "gst Amount" },
  { label: "Cess", value: "Cess" },
  // { label: "Net Amount", value: "Net Amount" },
];

export const debitNoteNonItemWiseEnteryTable = [
  {
    label: "Non Item Income/Sale Amount",
    value: "Income/sale Amount",
    flag: "required",
  },
  { label: "Reason", value: "Reason" },
  { label: "Non Item GST", value: "Non Item gst", flag: "required" },
  { label: "Non Item HSN/SA", value: "Non Item HSA/SA" },
  { label: "Description", value: "Description" },
  {
    label: "Non Item Taxable Amount",
    value: "Non Item Taxable Amount",
    flag: "required",
  },
  
  // { label: "Non Item GST Amount", value: "Non Item gstAmount" },
  { label: "Cess", Value: "Cess" },
  // { label: "Net Amount", value: "Net Amount" },
  // { label: "Total", value: "Total" },
];

export const crediNoteGeneral = [
  { label: "Customer/Suppiler", value: "Customer/Suppiler", flag: "required" },
  {
    label: "Customer/Supplier GSTIN",
    value: "Customer/Supplier gstin",
    flag: "required",
  },
  { label: "Billing Address", value: "Billing Address" },
  { label: "Delivery Address", value: "Delivery Address" },
  { label: "Place of Supply", value: "Place Of Supply", flag: "required" },
  {
    label: "Credit Note Number",
    value: "Credit note  Number",
    flag: "required",
  },
  { label: "Billing currency", value: "Billing Currency", flag: "required" },
  { label: "Credit Note Date", value: "Credit Note Date" },
  { label: "Customer Invoice Number", value: "Customer Invoice Number" },
  { label: "Taxablity", value: "taxablity", flag: "required" },
];

export const paymentVoucher = [
  { label: "Payment From", value: "Payment From" },
  { label: "Payment Date", value: "payment Date" },
  { label: "Payment Number Series", value: "Payment Number Series" },
  { label: "Bank Reference Number", value: "Bank Reference Number" },
  { label: "Paid To", value: "Paid To" },
  { label: "Payable Amount", value: "Payable Amount" },
  { label: "Less TDS Applicable", value: "Less TDS Applicable" },
  // { label: "TDS amount", value: "TDS Amount" },
  {
    label: "Amount Paid From Cash/Bank Account",
    value: "Amount Paid From Cash/Bank Account",
  },
  {
    label: "Towards", value: "Towards"
  },
  { label: "Narration", value: "Narration" },
];

export const receiptVoucher = [
  { label: "Received By", value: "Received By" },
  { label: "Payment Date", value: "payment Date" },
  { label: "Receipt Number Series", value: "Receipt Number Series" },
  { label: "Bank Reference Number", value: "Bank Reference Number" },
  { label: "Received From", value: "Received From" },
  { label: "Receivable Amount", value: "Receivable Amount" },
  { label: "Less TDS Applicable", value: "Less TDS Applicable" },
  // { label: "TDS amount", value: "TDS Amount" },
  {
    label: "Amount Received From Cash/Bank Account",
    value: "Amount Received From Cash/Bank Account",
  },
  {
    label: "Towards", value: "Towards"
  },
  { label: "Narration", value: "Narration" },
];

export const journalEntries = [
  { label: "Journal Prefix/Suffix", value: "Journal Prefix/PostFix" },
  { label:"Journal Voucher Date", value: "Journal Voucher Date"},
  { label: "Account", value: "Account" },
  { label: "Current Balance", value: "Current Balance" },
  { label: "Debit", value: "Debit" },
  { label: "Credit", value: "Credit" },
  { label: "Description", value: "Description" },
  { label: "Link", value: "Link" },
  // { label: "Total", value: "Total" },
];


export const salesExportData = [
  {accessor: "InvoiceDate", header: "Invoice Date", type: "date"},
  {accessor: "InvoiceNo", header: "Invoice No"},
  {accessor: "CustomerName", header: "Customer Name"},
  {accessor: "CustomerLegalName", header: "Customer Legal Name"},
  {accessor: "CustomerCategory", header: "Customer Category"},
  {accessor: "CustomerGSTIN", header: "Customer GSTIN"},
  {accessor: "PlaceofSupply", header: "Place of Supply"},
  {accessor: "BillingCurrency", header: "Billing Currency"},
  {accessor: "InvoiceAmout", header: "Invoice Amout"},
  {accessor: " AdditionalDiscount", header: " Additional Discount"},
  {accessor: "TCSAmount", header: "TCS Amount"},
  {accessor: " RoundOff", header: " Round Off (₹)"},
  {accessor: "NetAmount", header: "Net Amount (₹)"},
  {accessor: "DueDate", header: "Due Date", type: "date"},
  {accessor: "Due In/Overdue", header: "Due In/Overdue"},
  {accessor: "Status ", header: "Status "},
  {accessor: "IGST Rate", header: "IGST Rate (%)"},
  {accessor: "IGSTAmount", header: "IGST Amount (₹)"},
  {accessor: " CGSTRate", header: " CGST Rate(₹)"},
  {accessor: "SGST/UTGSTRate", header: "SGST/UTGST Rate (%)"},
  {accessor: "SGST/UTGSTAmount", header: "SGST/UTGST Amount (₹)"},
  {accessor: "CessRate", header: "Cess Rate (%)"},
  {accessor: "CessAmount", header: "Cess Amount (₹)"},
  {accessor: "TotalGSTAmount", header: "Total GST Amount (₹)"},
];